import { CatHeading } from '@blocks-react/components/Heading';

interface DealerLocatorFiltersHeaderProps {
  children: React.JSX.Element | string;
}

export const DealerLocatorFiltersHeader = ({
  children,
}: DealerLocatorFiltersHeaderProps) => (
  <CatHeading variant="title">{children}</CatHeading>
);
